@if (readOnly) {
<div class="crm-field-label">{{ label | translate }}</div>
<div class="crm-field-value">
  @if (control.value) {
  <span> {{ control.value }} </span>
  }
</div>
}
